import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LegalEntity} from 'src/app/domain/core/legal-entity.model';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    imports: [CommonModule]
})
export class ErrorComponent {
  legalEntity= LegalEntity.ToyotaGermany
}
